export default {
    startTime:"开始时间",
    endTime:"结束时间",
    to:"至",
    confirm:"确认要进行 ",
    opertion:" 操作?",
    enter:"确定",
    cancel:"取消",
    selectAll:"全选",
    sort:"序号",
    upload:"上传",
    imgUploading:"图片上传中",
    imgLimit:"只支持jpg、png、gif格式的图片！",
    add:"新增",
    update:"修改",
    drag:"将文件拖到此处，或",
    clickUpload:"点击上传",
    downTemplate:"下载模板",
    submit:"提交",
    write:"请填写 ",
    validate:"数据检验",
    uploadFail:"上传失败",
    uploadSuc:"上传成功",
    uploading:"正在上传...."


};
